import React from 'react';
import { createRoot } from 'react-dom/client';
import MassBioEvent from './App';
import reportWebVitals from './reportWebVitals';
import {HtmlComponent} from "./components/static/HtmlComponent";

import headerHtml from './components/static/header';
import footerHtml from './components/static/footer';

const placeholder_header = document.getElementById('placeholder_header');
if (placeholder_header) {
	createRoot(placeholder_header).render(
		<React.StrictMode>
			<HtmlComponent template={headerHtml}/>
		</React.StrictMode>
	);
}

const events_container = document.getElementById('massbio_event_container')
if (events_container) {
	createRoot(events_container).render(
		<React.StrictMode>
			<MassBioEvent/>
		</React.StrictMode>
	);
}

const placeholder_footer = document.getElementById('placeholder_footer');
if (placeholder_footer) {
	createRoot(placeholder_footer).render(
		<React.StrictMode>
			<HtmlComponent template={footerHtml}/>
		</React.StrictMode>
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
